module.exports = __webpack_public_path__ + "static/media/sold_out.843e3dc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/sold_out.svg
// module id = 96
// module chunks = 0